module.exports = __webpack_public_path__ + "asset/zhengpianActive_13jsresL.png";